import React, { useState, useEffect } from 'react'
import Wrapper from '../../components/Wrapper'
import { useParams, useNavigate, useLocation, useSearchParams } from 'react-router-dom'
import { Paper, Box, Typography, IconButton, Alert, TextField, Grid, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import InfoIcon from '@mui/icons-material/Info'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import { auto, global, input, menu, sip, weekDays, short } from '../../translate'
import { toast } from 'react-toastify'
import {
    inputStyles,
    selectStyles,
    inputLabelStyles,
    sectionTitleStyles,
    buttonStyles,
    greenTheme
} from '../../helpers/style'
import Api from '../../Api'
import AutoCallTimeCard from '../../components/new_component/AutoCallTimeCard'
import { DndContext, closestCorners, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core'
import { arrayMove, SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import { useDispatch, useSelector } from 'react-redux'
import { fileRequest } from '../../store/actions/file'
import AutoSelect from '../../components/AutoSelect'

const PAGE_SIZE = 10

function formatDateTimeForInput(val) {
    if (!val) return ''
    const d = new Date(val)
    if (Number.isNaN(d.getTime())) return ''
    const pad = (n) => String(n).padStart(2, '0')
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

function toIsoFromDateTimeLocal(value) {
    if (!value) return ''
    // value is expected as "YYYY-MM-DDTHH:mm" (from <input type="datetime-local" />)
    const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/)
    if (!m) return ''
    const year = Number(m[1])
    const month = Number(m[2])
    const day = Number(m[3])
    const hour = Number(m[4])
    const minute = Number(m[5])
    const d = new Date(year, month - 1, day, hour, minute, 0, 0) // local time (stable across OS)
    if (Number.isNaN(d.getTime())) return ''
    return d.toISOString()
}

export default function AutoCallSingle() {
    const { id } = useParams()
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()
    const dispatch = useDispatch()
    const langIndex = +localStorage.getItem('atsLang') || 1
    const [saving, setSaving] = useState(false)
    const [loading, setLoading] = useState(false)
    const [form, setForm] = useState({
        line: '',
        type: 'auto',
        name: '',
        groupDateTime: formatDateTimeForInput(new Date()),
        time: [{
            id: new Date().toISOString(),
            num: '',
            weekStart: weekDays[1][langIndex],
            weekEnd: weekDays[0][langIndex],
            timeStart: '00:00',
            timeEnd: '23:59',
            attempt: 2,
            okStart: 0,
            okEnd: 60,
            phone: ''
        }]
    })
    const files = useSelector(state => state.file.fileData)
    const [inAuto, setInAuto] = useState([])
    const [inAuto1, setInAuto1] = useState([])
    const [inAuto1SingleItem, setInAuto1SingleItem] = useState([])
    const [isOrdered, setIsOrdered] = useState(false)
    const [page, setPage] = useState(1)
    const isEdit = id && id !== 'add'
    const campaignType = searchParams.get('campaignType') || location.state?.campaignType
    const fromList = searchParams.get('fromList') || location.state?.fromList
    const isTypeLocked = (campaignType === 'autocall' || campaignType === 'group') || (isEdit && (fromList === 'autocall' || fromList === 'group'))

    const sensors = useSensors(
        useSensor(MouseSensor, {
            activationConstraint: {
                distance: 5,
            },
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: 100,
                tolerance: 5,
            },
        })
    )

    useEffect(() => {
        fetchInAuto()
        if (form.type === 'group' && (!files || files.length === 0)) {
            dispatch(fileRequest(1))
        }
    }, [form.type, dispatch])

    useEffect(() => {
        if (isEdit) {
            fetchAutoCall()
        }
    }, [id])

    useEffect(() => {
        const uploaded = location.state?.uploadedTime
        if (id === 'add' && Array.isArray(uploaded) && uploaded.length > 0) {
            setForm((prev) => ({ ...prev, time: uploaded }))
            const q = new URLSearchParams(searchParams)
            q.delete('uploadedTime')
            const search = q.toString() ? `?${q.toString()}` : ''
            navigate(`/auto_call_single/add${search}`, { replace: true, state: { ...location.state, uploadedTime: undefined } })
        }
    }, [id, location.state?.uploadedTime, navigate, searchParams])

    useEffect(() => {
        if (!isEdit && campaignType) {
            setForm((prev) => ({
                ...prev,
                type: campaignType === 'group' ? 'group' : 'auto'
            }))
        }
    }, [isEdit, campaignType])


    const fetchInAuto = async () => {
        try {
            const { data } = await Api.getInAuto()
            setInAuto(data.inputNumber?.buddies || [])
            setInAuto1(data.inputNumber?.shorts || [])
            setInAuto1SingleItem(data.inputNumber?.shortsSingleItem || [])
        } catch (error) {
            console.error('Error fetching in auto:', error)
        }
    }

    const fetchAutoCall = async () => {
        setLoading(true)
        try {
            const { data } = await Api.singleAuto(id)
            const dataItem = data.dataItem

            const nameValue = typeof dataItem.name === 'string'
                ? dataItem.name
                : dataItem.name?.name || dataItem.name || ''
            const timeoutValue = typeof dataItem.name === 'object'
                ? dataItem.name?.timeout || ''
                : ''

            setForm({
                type: dataItem.isivr === 3 ? 'group' : 'auto',
                line: dataItem.virtual || '',
                name: nameValue,
                timeout: timeoutValue,
                groupDateTime: dataItem.isivr === 3
                    ? formatDateTimeForInput(data.memberGroupsItems?.find(s => s?.lastupdated)?.lastupdated || data.memberGroupsItems?.[0]?.lastupdated || new Date())
                    : formatDateTimeForInput(new Date()),
                time: data.memberGroupsItems?.map(s => {
                    const isGroup = dataItem.isivr === 3
                    let num = ''
                    if (isGroup) {
                        num = String(s.buddy ?? '')
                    } else {
                        const member = [...(data.memberGroups || []), ...(data.memberGroups1 || [])]
                            .find(m => +m.azang === +s.buddy)
                        // For auto call, keep only the numeric azang value without label/comment
                        num = member ? String(member.azang) : ''
                    }

                    const days = s.days?.split('-') || []
                    const hours = s.hours?.split('-') || []

                    return {
                        id: s.id || new Date().toISOString(),
                        num: num,
                        weekStart: days[0] ? weekDays[+days[0] - 1]?.[langIndex] : weekDays[1][langIndex],
                        weekEnd: days[1] ? weekDays[+days[1] - 1]?.[langIndex] : weekDays[0][langIndex],
                        timeStart: hours[0] || '00:00',
                        timeEnd: hours[1] || '23:59',
                        attempt: s.rlimit || 2,
                        okStart: s.okinterval || 0,
                        okEnd: s.nokinterval || 60,
                        phone: s.dnumber || '',
                        start: isGroup ? s.lastupdated : undefined
                    }
                }) || []
            })

            if (dataItem.isivr === 3 && (!files || files.length === 0)) {
                await dispatch(fileRequest(1))
            }

            const { data: inAutoData } = await Api.getInAuto()
            setInAuto(inAutoData.inputNumber?.buddies || [])
            setInAuto1(inAutoData.inputNumber?.shorts || [])
            setInAuto1SingleItem(inAutoData.inputNumber?.shortsSingleItem || [])
        } catch (error) {
            console.error('Error fetching auto call:', error)
            toast.error('Error loading auto call data')
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (name, value) => {
        if (name === 'type') {
            setForm(prev => ({
                ...prev,
                [name]: value,
                time: [] // Reset time when type changes
            }))
        } else {
            setForm(prev => ({
                ...prev,
                [name]: value
            }))
        }
    }

    const handleGoBack = () => {
        const goToGroupList = fromList === 'group' || campaignType === 'group' || form.type === 'group'
        navigate(goToGroupList ? '/group_call_list' : '/auto_call_list')
    }

    const handleSave = async () => {
        if (!form.name || !form.name.trim()) {
            toast.error(input.required[langIndex] || 'Name is required')
            return
        }

        if (!form.line || !form.line.toString().trim()) {
            toast.error(input.required[langIndex] || 'Line is required')
            return
        }

        let payload = { ...form }
        if (form.type === 'group') {
            const lineStr = form.line.toString().replace(/\D/g, '')
            if (lineStr.length !== 4) {
                toast.error(langIndex === 2 ? 'Номер должен содержать 4 цифры' : langIndex === 3 ? 'Համարը պետք է պարունակի 4 թվանշան' : 'Number must be exactly 4 digits')
                return
            }
            const dateIso = toIsoFromDateTimeLocal(form.groupDateTime) || new Date().toISOString()
            payload = {
                ...payload,
                line: lineStr,
                time: (payload.time || []).map((t) => ({
                    ...t,
                    // backend still expects these fields; keep them as full-range defaults
                    weekStart: t.weekStart ?? weekDays[1][langIndex],
                    weekEnd: t.weekEnd ?? weekDays[0][langIndex],
                    timeStart: t.timeStart ?? '00:00',
                    timeEnd: t.timeEnd ?? '23:59',
                    date: dateIso,
                })),
            }
        }

        if (!form.time || form.time.length === 0) {
            toast.error(input.required[langIndex] || 'At least one time configuration is required')
            return
        }

        setSaving(true)
        try {
            if (isEdit) {
                await Api.editAuto(payload, id)
                toast.success(global.success[langIndex] || 'Auto call updated successfully')
            } else {
                await Api.createAuto(payload)
                toast.success(global.success[langIndex] || 'Auto call created successfully')
            }
            navigate(campaignType === 'group' || fromList === 'group' ? '/group_call_list' : '/auto_call_list')
        } catch (error) {
            console.error('Error saving auto call:', error)
            toast.error(error?.response?.data?.message || global.error[langIndex] || 'Error saving auto call')
        } finally {
            setSaving(false)
        }
    }

    const totalItems = form.time?.length || 0
    const totalPages = Math.max(1, Math.ceil(totalItems / PAGE_SIZE))
    const currentPage = Math.min(page, totalPages)
    const startIndex = (currentPage - 1) * PAGE_SIZE
    const endIndex = startIndex + PAGE_SIZE
    const visibleTime = form.time.slice(startIndex, endIndex)

    useEffect(() => {
        if (page > totalPages) {
            setPage(totalPages)
        }
    }, [totalPages, page])

  return (
        <Wrapper>
            <div className="tableParent">
                <Paper sx={{ p: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3, borderBottom: '2px solid rgba(0, 0, 0, 0.08)', pb: 2.5 }}>
                        <IconButton
                            size="small"
                            sx={{ color: greenTheme.primary, fontSize: 18 }}
                            onClick={handleGoBack}
                            aria-label="Back"
                        >
                            <ArrowBackIosNewIcon sx={{ fontSize: 20, fontWeight: 700 }} />
                        </IconButton>
                        <Typography variant="h5" sx={{ fontWeight: 700, m: 0 }}>
                            {isEdit ? global.edit[langIndex] : sip.add_btn[langIndex]} {(campaignType === 'group' || fromList === 'group') ? menu.autoCall2[langIndex] : (campaignType === 'autocall' || fromList === 'autocall') ? menu.autoCall1[langIndex] : menu.autoCall[langIndex]}
                        </Typography>
                    </Box>

                    <Alert icon={<InfoIcon />} severity="success" sx={{ mb: 3 }}>
                        <Typography variant="body2">
                            {auto.add[langIndex]}
                        </Typography>
                    </Alert>

                    <Paper sx={{ p: 3, border: `1px solid ${greenTheme.primary}` }}>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" sx={sectionTitleStyles}>
                                {((campaignType === 'group' || fromList === 'group') ? menu.autoCall2 : (campaignType === 'autocall' || fromList === 'autocall') ? menu.autoCall1 : menu.autoCall)[langIndex]} {global.edit[langIndex] || 'Information'}
                            </Typography>
                        </Box>

                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                {form.type === 'group' ? (
                                    <TextField
                                        fullWidth
                                        label={auto.connectToCallNumber[langIndex]}
                                        value={form.line}
                                        onChange={(e) => {
                                            const digits = e.target.value.replace(/\D/g, '').slice(0, 4)
                                            handleChange('line', digits)
                                        }}
                                        inputProps={{ maxLength: 4, inputMode: 'numeric' }}
                                        required
                                        sx={inputStyles}
                                        InputLabelProps={{ sx: inputLabelStyles }}
                                        placeholder={langIndex === 2 ? '4 цифры' : langIndex === 3 ? '4 թվանշան' : '4 digits'}
                                    />
                                ) : (
                                    <TextField
                                        fullWidth
                                        label={auto.line[langIndex]}
                                        value={form.line}
                                        onChange={(e) => handleChange('line', e.target.value)}
                                        type="number"
                                        required
                                        sx={inputStyles}
                                        InputLabelProps={{ sx: inputLabelStyles }}
                                    />
                                )}
                            </Grid>

                            {!isTypeLocked && (
                                <Grid item xs={12} sm={6}>
                                    <FormControl fullWidth required>
                                        <InputLabel sx={inputLabelStyles}>{auto.type[langIndex]}</InputLabel>
                                        <Select
                                            value={form.type}
                                            onChange={(e) => handleChange('type', e.target.value)}
                                            label={auto.type[langIndex]}
                                            sx={selectStyles}
                                        >
                                            <MenuItem value="auto">Auto call</MenuItem>
                                            <MenuItem value="group">Group call</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                            )}

                            <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label={auto.name[langIndex]}
                                    value={form.name}
                                    onChange={(e) => handleChange('name', e.target.value)}
                                    required
                                    sx={inputStyles}
                                    InputLabelProps={{ sx: inputLabelStyles }}
                                />
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 4 }}>
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="h6" sx={sectionTitleStyles}>
                                    {short.time[langIndex]} {auto.type[langIndex]}
                                </Typography>
                            </Box>

                            {form.type === 'group' && form.time.length > 0 && (
                                <Paper sx={{ p: 3, mb: 3, border: `1px solid ${greenTheme.primary}`, borderRadius: 1 }}>
                                    <Typography variant="subtitle1" sx={{ ...sectionTitleStyles, mt: 0, mb: 2 }}>
                                        {langIndex === 1 ? 'Date & time (for all items)' : langIndex === 2 ? 'Дата и время (для всех)' : 'Ամսաթիվ և ժամ (բոլորի համար)'}
                                    </Typography>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                label={langIndex === 1 ? 'Date & time' : langIndex === 2 ? 'Дата и время' : 'Ամսաթիվ և ժամ'}
                                                type="datetime-local"
                                                value={form.groupDateTime || ''}
                                                onChange={(e) => handleChange('groupDateTime', e.target.value)}
                                                InputLabelProps={{ shrink: true, sx: inputLabelStyles }}
                                                sx={{
                                                    ...inputStyles,
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: 2,
                                                        backgroundColor: '#fafbfc',
                                                        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: `${greenTheme.primary}66` },
                                                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: greenTheme.primary, borderWidth: 2 },
                                                    },
                                                }}
                                                inputProps={{ step: 60 }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            )}

                            <DndContext
                                sensors={sensors}
                                collisionDetection={closestCorners}
                                onDragEnd={(event) => {
                                    const { active, over } = event
                                    if (active.id !== over?.id) {
                                        setForm((prev) => {
                                            const oldIndex = prev.time.findIndex((item) => (item.id || 0) === active.id)
                                            const newIndex = prev.time.findIndex((item) => (item.id || 0) === over?.id)
                                            return {
                                                ...prev,
                                                time: arrayMove(prev.time, oldIndex, newIndex),
                                            }
                                        })
                                    }
                                }}
                            >
                                <SortableContext items={visibleTime.map(t => t.id || 0)} strategy={verticalListSortingStrategy}>
                                    {form.type === 'group' ? (
                                        <Grid container spacing={1}>
                                            {visibleTime.map((timeItem, index) => (
                                                <Grid item xs={12} key={timeItem.id || index}>
                                                    <AutoCallTimeCard
                                                        timeItem={timeItem}
                                                        index={startIndex + index}
                                                        form={form}
                                                        setForm={setForm}
                                                        langIndex={langIndex}
                                                        greenTheme={greenTheme}
                                                        inputStyles={inputStyles}
                                                        inputLabelStyles={inputLabelStyles}
                                                        selectStyles={selectStyles}
                                                        auto={auto}
                                                        short={short}
                                                        weekDays={weekDays}
                                                        input={input}
                                                        sip={sip}
                                                        isOrdered={isOrdered}
                                                        inAuto={inAuto}
                                                        inAuto1={inAuto1}
                                                        inAuto1SingleItem={inAuto1SingleItem}
                                                        files={files}
                                                        isGroup={true}
                                                        AutoSelect={AutoSelect}
                                                    />
                                                </Grid>
                                            ))}
                                        </Grid>
                                    ) : (
                                        visibleTime.map((timeItem, index) => (
                                            <AutoCallTimeCard
                                                key={timeItem.id || index}
                                                timeItem={timeItem}
                                                index={startIndex + index}
                                                form={form}
                                                setForm={setForm}
                                                langIndex={langIndex}
                                                greenTheme={greenTheme}
                                                inputStyles={inputStyles}
                                                inputLabelStyles={inputLabelStyles}
                                                selectStyles={selectStyles}
                                                auto={auto}
                                                short={short}
                                                weekDays={weekDays}
                                                input={input}
                                                sip={sip}
                                                isOrdered={isOrdered}
                                                inAuto={inAuto}
                                                inAuto1={inAuto1}
                                                inAuto1SingleItem={inAuto1SingleItem}
                                                files={files}
                                                isGroup={form.type === 'group'}
                                                AutoSelect={AutoSelect}
                                            />
                                        ))
                                    )}
                                </SortableContext>
                            </DndContext>

                            {totalPages > 1 && (
                                <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1 }}>
                                    <Typography variant="caption" color="text.secondary">
                                        {`${startIndex + 1}-${Math.min(endIndex, totalItems)} / ${totalItems}`}
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            disabled={currentPage === 1}
                                            onClick={() => setPage(p => Math.max(1, p - 1))}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            {langIndex === 2 ? 'Назад' : langIndex === 3 ? 'Նախ.' : 'Prev'}
                                        </Button>
                                        <Button
                                            size="small"
                                            variant="outlined"
                                            disabled={currentPage === totalPages}
                                            onClick={() => setPage(p => Math.min(totalPages, p + 1))}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            {langIndex === 2 ? 'Далее' : langIndex === 3 ? 'Հաջ.' : 'Next'}
                                        </Button>
                                    </Box>
                                </Box>
                            )}

                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start', gap: 2, flexWrap: 'wrap' }}>
                                <Button
                                    variant="contained"
                                    onClick={() => {
                                        const first = form.time[0]
                                        setForm(prev => ({
                                            ...prev,
                                            time: [...prev.time, {
                                                id: new Date().toISOString(),
                                                num: '',
                                                weekStart: first?.weekStart ?? weekDays[1][langIndex],
                                                weekEnd: first?.weekEnd ?? weekDays[0][langIndex],
                                                timeStart: first?.timeStart ?? '00:00',
                                                timeEnd: first?.timeEnd ?? '23:59',
                                                attempt: 2,
                                                okStart: first?.okStart ?? 0,
                                                okEnd: first?.okEnd ?? 60,
                                                phone: ''
                                            }]
                                        }))
                                    }}
                                    sx={{
                                        backgroundColor: greenTheme.primary,
                                        '&:hover': {
                                            backgroundColor: greenTheme.hover,
                                        },
                                    }}
                                >
                                    {sip.add_btn[langIndex]}
                                </Button>
                                {isEdit && (
                                    <Button
                                        variant="outlined"
                                        startIcon={<UploadFileIcon />}
                                        onClick={() => navigate(`/auto_call_single/upload/${id}`, { state: { campaignType, fromList } })}
                                        sx={{
                                            borderColor: greenTheme.primary,
                                            color: greenTheme.primary,
                                            textTransform: 'none',
                                            '&:hover': {
                                                borderColor: greenTheme.hover,
                                                backgroundColor: `${greenTheme.primary}10`,
                                            },
                                        }}
                                    >
                                        {langIndex === 1 ? 'Upload file' : langIndex === 2 ? 'Загрузить файл' : 'Վերբեռնել ֆայլ'}
                                    </Button>
                                )}
                            </Box>
                        </Box>

                        <Box sx={{ mt: 8, display: 'flex', justifyContent: 'flex-end' }}>
                            <Button
                                variant="contained"
                                color="inherit"
                                onClick={handleSave}
                                disabled={saving || loading}
                                size="small"
                                sx={{
                                    ...buttonStyles,
                                    backgroundColor: '#7ebc0a !important',
                                    color: '#fff !important',
                                    '&:hover': {
                                        backgroundColor: '#6aa309 !important',
                                        color: '#fff !important',
                                    },
                                    '&:focus': { color: '#fff !important' },
                                    '&:disabled': { backgroundColor: '#a0c97a !important', color: '#fff !important' },
                                }}
                            >
                                {saving ? (global.edit[langIndex] || 'Saving...') : (global.edit[langIndex] || 'Save')}
                            </Button>
                        </Box>
                    </Paper>
                </Paper>
            </div>
        </Wrapper>
  )
}
